/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Post_CodeInputs */

const en_admin_external_booking_edit_post_code = /** @type {(inputs: Admin_External_Booking_Edit_Post_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post code`)
};

const de_admin_external_booking_edit_post_code = /** @type {(inputs: Admin_External_Booking_Edit_Post_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postleitzahl`)
};

const es_admin_external_booking_edit_post_code = /** @type {(inputs: Admin_External_Booking_Edit_Post_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código postal`)
};

const fr_admin_external_booking_edit_post_code = /** @type {(inputs: Admin_External_Booking_Edit_Post_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code postal`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Post_CodeInputs) => LocalizedString} */
const it_admin_external_booking_edit_post_code = en_admin_external_booking_edit_post_code;

/** @type {(inputs: Admin_External_Booking_Edit_Post_CodeInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_post_code = en_admin_external_booking_edit_post_code;

/** @type {(inputs: Admin_External_Booking_Edit_Post_CodeInputs) => LocalizedString} */
const pl_admin_external_booking_edit_post_code = en_admin_external_booking_edit_post_code;

/** @type {(inputs: Admin_External_Booking_Edit_Post_CodeInputs) => LocalizedString} */
const hu_admin_external_booking_edit_post_code = en_admin_external_booking_edit_post_code;

/** @type {(inputs: Admin_External_Booking_Edit_Post_CodeInputs) => LocalizedString} */
const ro_admin_external_booking_edit_post_code = en_admin_external_booking_edit_post_code;

/**
* | output |
* | --- |
* | "Post code" |
*
* @param {Admin_External_Booking_Edit_Post_CodeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_post_code = /** @type {((inputs?: Admin_External_Booking_Edit_Post_CodeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Post_CodeInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_post_code(inputs)
	if (locale === "de") return de_admin_external_booking_edit_post_code(inputs)
	if (locale === "es") return es_admin_external_booking_edit_post_code(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_post_code(inputs)
	if (locale === "it") return it_admin_external_booking_edit_post_code(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_post_code(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_post_code(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_post_code(inputs)
	return ro_admin_external_booking_edit_post_code(inputs)
});
export { admin_external_booking_edit_post_code as "admin.external_booking_edit.post_code" }